var React = require("react"),
    InCentrePayment = require("./index");

module.exports = () => (
    <div className="in-centre-payment-form">
        <InCentrePayment />
    </div>
);
